import "core-js/modules/es6.number.constructor";
export default {
  name: 'UiLoadCard',
  props: {
    // [{ key, label, state: 'todo' | 'busy' | 'done', count }]
    steps: {
      type: Array,
      required: true
    },
    progress: {
      type: Number,
      default: 0
    },
    look: {
      type: String,
      default: 'duin'
    },
    title: {
      type: String,
      default: ''
    },
    failed: {
      type: Boolean,
      default: false
    },
    // no entrance (the card and its steps are there at once): it takes over from another card in the same place
    still: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    counted: function counted() {
      return this.steps.some(function (step) {
        return step.count !== undefined;
      });
    }
  }
};